module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_senior_right-ee8049c1916e2ab3f9fdd8535b988155.png";